"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fireUpgradeStepTelemetry = exports.UpgradeDiscoveryViewedTelemetry = void 0;
var Telemetry_1 = require("@CommonFrontend/Telemetry");
var inversify_react_1 = require("inversify-react");
var react_1 = __importDefault(require("react"));
var UpgradeDiscoveryViewedTelemetry = function (_a) {
    var telemetryOrigin = _a.telemetryOrigin, children = _a.children;
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    return (react_1.default.createElement("div", { onMouseEnter: function () { return fireUpgradeStepTelemetry(telemetry, telemetryOrigin, "discovery_viewed"); } }, children));
};
exports.UpgradeDiscoveryViewedTelemetry = UpgradeDiscoveryViewedTelemetry;
function fireUpgradeStepTelemetry(telemetry, telemetryOrigin, stepType) {
    telemetry.trackOnly(Telemetry_1.TelemetryEventName.UpgradeStepTaken, {
        event_origin: telemetryOrigin,
        step_type: stepType,
    }, { blockIntercom: true });
}
exports.fireUpgradeStepTelemetry = fireUpgradeStepTelemetry;
